import { SET_PROVIDERS } from '~/store/feature/Provider';
import { api } from '../api';
import { PROVIDERS_PATH } from '../endpoints';
import { GlobalResponse, ProviderItem } from '~/models/Commons ';
import { getHeaders } from '../generics/Header';

const extendedApiSlice = api.injectEndpoints({
    endpoints: builder => ({
        getProviders: builder.query<GlobalResponse<ProviderItem[]>, void>({
            query: () => ({
                url: PROVIDERS_PATH,
                method: 'GET',
                credentials: 'include',
                headers:getHeaders()  
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                dispatch(SET_PROVIDERS(data.payload));
            },
        }),
    }),
});

export const { useGetProvidersQuery } = extendedApiSlice;

